/*
 *  This file user-avatar.component.ts is part of HROne Inbox. The intelectual property owned by Uneecops Workplace Solution PVT. LTD.
 *  CopyrightYear: 2025
 *  (C) 2015-2025. All Right reserved. Uneecops Workplace Solution PVT. LTD.
 */

import { ChangeDetectorRef, Component, DestroyRef, HostListener, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { CandidateSessionSyncService } from '../../services/candidate-session-sync.service';
import { SharedService } from '../../services/shared.service';
import { MatMenuModule } from '@angular/material/menu';

@Component({
  selector: 'app-user-avatar',
  templateUrl: './user-avatar.component.html',
  styleUrls: ['./user-avatar.component.scss'],
  imports: [MatMenuModule]
})
export class UserAvatarComponent implements OnInit {
  public readonly _shared = inject(SharedService);
  private readonly _cdr = inject(ChangeDetectorRef);
  private readonly _router = inject(Router);
  private readonly _destroyRef = inject(DestroyRef);
  private readonly _sessionSync = inject(CandidateSessionSyncService);

  // candidate the current link belongs to (from ?cid= / ?dc=), refreshed on every navigation
  private linkMobile = '';
  private linkDomainCode = '';

  ngOnInit(): void {
    this.readLinkCandidate();
    this._router.events
      .pipe(filter(event => event instanceof NavigationEnd), takeUntilDestroyed(this._destroyRef))
      .subscribe(() => this.readLinkCandidate());
  }

  /** Show only when logged in AND the stored session belongs to the candidate of the open link. */
  protected isAvatarVisible(): boolean {
    if (!this._shared.isLogin()) return false;
    if(this._router.url.includes('/blob')) return false;
    if (this.linkMobile) return this._sessionSync.isSameCandidate(this.linkMobile, this.linkDomainCode);
    if (this.linkDomainCode) return localStorage.getItem('domainCode') == this.linkDomainCode;
    return true;
  }

  private readLinkCandidate(): void {
    const params = this._router.parseUrl(this._router.url).queryParams;
    this.linkMobile = this._sessionSync.getLinkMobile(params['cid']);
    this.linkDomainCode = params['dc'] ?? '';
  }

  // Fires only in *other* tabs when localStorage changes (e.g. logout/login elsewhere) — re-render so isAvatarVisible() is re-evaluated
  @HostListener('window:storage', ['$event'])
  protected onStorageChange(event: StorageEvent): void {
    if (event.key === null || event.key === 'mob' || event.key === 'domainCode') {
      this._cdr.markForCheck();
    }
  }

  protected logout(): void {
    // logoutUser clears 'mob' / 'domainCode' on success, which hides the avatar via isAvatarVisible();
    // then notify this tab's open page so it drops back to the OTP screen like the other tabs do
    this._shared.logoutUser(localStorage.getItem('domainCode') ?? '', '', () => this._sessionSync.notifyLocalChange());
  }
}
